import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Input from 'components/shared/Input/Input';
import Select from 'components/shared/Select/Select';

import BillingAddressInformation from './BillingAddressInformation';

const BillingProviderForm = ({
  formik,
  tax_id_types,
  selectedState,
  handleSelectState,
  states,
  customSelectStyle,
  selectedPractitioners,
  selectPractitioners,
  practitioners
}) => {
  const handleDigitsOnlyChange = (key) => (e) => {
    const onlyDigits = e.target.value.replace(/\D/g, '');
    formik.setFieldValue(key, onlyDigits);
  };
  return (
    <form>
      <div className="flex flex-col gap-2">
        <h3 className="text-xl">Billing information</h3>
        <div className="grid grid-cols-2 gap-3 pb-7">
          <Input
            id="name"
            type="text"
            label="Name"
            name="bill_name"
            placeholder="Name"
            onChange={formik.handleChange}
            value={formik.values.bill_name}
            error={formik.touched.bill_name && formik.errors.bill_name}
          />

          <Input
            id="npi"
            type="text"
            name="bill_npi"
            label="Billing NPI"
            placeholder="Billing NPI"
            value={formik.values.bill_npi}
            onChange={handleDigitsOnlyChange('bill_npi')}
            error={formik.touched.bill_npi && formik.errors.bill_npi}
          />

          <Input
            id="taxid"
            type="text"
            name="bill_taxid"
            label="Billing Tax ID"
            placeholder="Billing Tax ID"
            onChange={handleDigitsOnlyChange('bill_taxid')}
            value={formik.values.bill_taxid}
            error={formik.touched.bill_taxid && formik.errors.bill_taxid}
          />

          <Select
            inputId="taxidType"
            options={tax_id_types}
            styles={customSelectStyle}
            label="Billing Tax ID Type"
            placeholder="Billing Tax ID Type"
            value={formik.values.bill_taxid_type}
            onChange={(value) => formik.setFieldValue('bill_taxid_type', value)}
            error={formik.touched.bill_taxid_type && formik.errors.bill_taxid_type}
          />
          <div>
            <label className="label" htmlFor="id">
              Billing Taxonomy
            </label>
            <Input
              type="text"
              id="taxonomy"
              name="bill_taxonomy"
              placeholder="Billing Taxonomy"
              onChange={formik.handleChange}
              value={formik.values.bill_taxonomy}
            />
            {formik.errors.bill_taxonomy && (
              <span className="!pt-2 text-left text-sm text-danger-500">
                {formik.errors.bill_taxonomy}
              </span>
            )}
          </div>
          <div>
            <label className="label" htmlFor="id">
              Billing Atypical ID
            </label>
            <Input
              type="text"
              placeholder="Billing Atypical ID"
              name="bill_id"
              value={formik.values.bill_id}
              onChange={formik.handleChange}
              id="id"
            />
            {formik.errors.bill_id && (
              <span className="!pt-2 text-left text-sm text-danger-500">
                {formik.errors.bill_id}
              </span>
            )}
          </div>
          <div>
            <label className="label" htmlFor="phoneNumber">
              Phone number
            </label>
            <Input
              type="text"
              placeholder="+1(123)4567890"
              name="bill_phone"
              value={formik.values.bill_phone}
              onChange={formik.handleChange}
              id="phoneNumber"
            />
            {formik.errors.bill_phone && (
              <span className="!pt-2 text-left text-sm text-danger-500">
                {formik.errors.bill_phone}
              </span>
            )}
          </div>
        </div>
      </div>

      <BillingAddressInformation
        formik={formik}
        selectedState={selectedState}
        handleSelectState={handleSelectState}
        states={states}
        customSelectStyle={customSelectStyle}
      />
      <div className="grid grid-cols-2 pt-7">
        <div className="flex flex-col gap-3">
          <h3 className="text-xl">Practitioners</h3>
          <div className="flex flex-col">
            <label className="label" htmlFor="practitioner">
              Practitioners
            </label>
            <Select
              menuPortalTarget={document.body}
              placeholder="Type and select practitioners"
              value={selectedPractitioners}
              onChange={(e, v) => selectPractitioners(e, v)}
              options={practitioners}
              styles={customSelectStyle}
              inputId="practitioner"
              menuPlacement="top"
              isMulti={true}
            />
            {formik.errors.practitioner_ids && (
              <span className="!pt-2 text-left text-sm text-danger-500">
                {formik.errors.practitioner_ids}
              </span>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};

export default withErrorBoundary(BillingProviderForm);
